// Import model
import { TextFieldOptions } from '../models/TextFieldOptions';

// Import base class serializer
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for TextFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class TextFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a TextFieldOptions instance
   */
  static deserialize(json: string): TextFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a TextFieldOptions instance
   */
  static fromObject(obj: any): TextFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to TextFieldOptions');
    }


    const instance: TextFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      multline: obj['Multline'] as boolean | undefined,
      contentType: obj['ContentType'] as string | undefined,
      format: obj['Format'] as string | undefined,
      maxLength: obj['MaxLength'] as number | undefined,
      allowExpressions: obj['AllowExpressions'] as boolean | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of TextFieldOptions instances
   */
  static deserializeArray(json: string): TextFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a TextFieldOptions instance to a JSON string
   */
  static serialize(instance: TextFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a TextFieldOptions instance to a plain object
   */
  static toObject(instance: TextFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      'Multline': instance.multline,
      'ContentType': instance.contentType,
      'Format': instance.format,
      'MaxLength': instance.maxLength,
      'AllowExpressions': instance.allowExpressions,
    };
  }

  /**
   * Serializes an array of TextFieldOptions instances to a JSON string
   */
  static serializeArray(instances: TextFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
